import {KecPath, Service, Version, source} from './constants';
//查询
export const getSnapStrategyList = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeAutoSnapshotPolicy',
        Service,
        Version,
        source
    }
};
//创建策略
export const createSnapStra = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'CreateAutoSnapshotPolicy',
        Service,
        Version,
        source
    }
};
//修改策略
export const modifyStrategy = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'ModifyAutoSnapshotPolicy',
        Service,
        Version,
        source
    }
};
//删除策略
export const deleteStrategy = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DeleteAutoSnapshotPolicy',
        Service,
        Version,
        source
    }
};
//执行自动快照策略
export const applyStrategy = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'ApplyAutoSnapshotPolicy',
        Service,
        Version,
        source
    }
};  
//取消执行自动快照策略
export const cancelStrategy = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'CancelAutoSnapshotPolicy',
        Service,
        Version,
        source
    }
};
//设置本地盘备份策略
export const bindStrategy = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'AssociatedAutoSnapshotPolicy',
        Service,
        Version,
        source
    }
};
//获取下次快照时间
export const getnextSnapTime = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'GetSnapshotTime',
        Service,
        Version,
        source
    }
};
//白名单验证
export const validateSnapStra = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'ValidateAutoSnapshot',
        Service,
        Version,
        source,
        ValidateKey:'AutoSnapshot',
    },  
};

//目前只在自动快照策略里 白名单验证 因为返回值不一样，Mainview里面也会调白名单验证，不确定谁会先返回，所以新增一个
export const validateEbsAndLocalSnapStra = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'ValidateAutoSnapshot',
        Service,
        Version,
        source,
        ValidateKey:'ALL',
    },  
    options: {
        notAbort: true,
    },
};

//获取策略数量
export const GetAutoSnapshotQuota = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'GetAutoSnapshotQuota',
        Service,
        Version,
        source
    },  
};